/**
 * FamiliarisationFooter - Footer navigation component
 */

import React from 'react';
import { ChevronLeft, ChevronRight, Save, RotateCcw } from 'lucide-react';
// Using HTML buttons instead of Catalyst Button due to modal visibility issues

const FamiliarisationFooter = ({
  currentStep,
  sectionsLength,
  viewMode,
  allTopicsCompleted,
  familiarisationComplete,
  crewSignature,
  assessorSignature,
  isSubmitting,
  onPrevious,
  onNext,
  onClearProgress,
  onComplete,
  crewId
}) => {
  const handleClearProgress = () => {
    if (window.confirm('Clear all progress and restart familiarisation? This cannot be undone.')) {
      onClearProgress();
      localStorage.removeItem(`familiarisation_progress_${crewId}`);
    }
  };

  return (
    <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {!viewMode && (
          <>
            <button
              type="button"
              className="px-3 py-1.5 text-sm bg-white border border-red-300 text-red-700 rounded-md hover:bg-red-50 flex items-center"
              onClick={handleClearProgress}
            >
              <RotateCcw className="h-4 w-4 mr-2" />
              Clear Progress
            </button>
            <span className="text-xs text-green-700 bg-green-100 px-2 py-1 rounded">
              ✓ Auto-saving progress
            </span>
          </>
        )}
      </div>

      <div className="flex items-center gap-3">
        <span className="text-xs text-gray-600 mr-2">
          Step {currentStep + 1} of {sectionsLength}
        </span>
        <button
          type="button"
          className="px-3 py-1.5 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          onClick={onPrevious}
          disabled={currentStep === 0}
        >
          <ChevronLeft className="h-4 w-4 mr-1" />
          Previous
        </button>

        {currentStep < sectionsLength ? (
          <button
            type="button"
            className="px-3 py-1.5 text-sm bg-cyan-600 text-white rounded-md hover:bg-cyan-700 flex items-center"
            onClick={onNext}
          >
            {currentStep === sectionsLength - 1 ? 'Review & Sign-off' : 'Next Section'}
            <ChevronRight className="h-4 w-4 ml-1" />
          </button>
        ) : (
          <button
            type="button"
            className="px-3 py-1.5 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center"
            onClick={onComplete}
            disabled={!allTopicsCompleted || !familiarisationComplete || !crewSignature || !assessorSignature || isSubmitting || viewMode}
          >
            {isSubmitting ? (
              <>
                <div className="animate-spin -ml-1 mr-2 h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
                Completing...
              </>
            ) : (
              <>
                <Save className="h-4 w-4 mr-2" />
                Complete & Sign
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default FamiliarisationFooter;